import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import "global/window";
import { AppModule } from "./app/app.module";
import { environment } from "environment";
(window as any).global = window;

declare global {
  interface Window {
    _paq?: any[];
  }
}

window._paq = window._paq || [];
window._paq.push(['setRequestMethod', 'beacon']);

// Load PageSense dynamically
function loadPageSense(): Promise<void> {
  return new Promise((resolve, reject) => {
    // Disabled → skip completely
    if (!environment.enablePagesense) {
      resolve();
      return;
    }

    // No URL → skip
    if (!environment.pagesenseUrl) {
      resolve();
      return;
    }

    // Avoid duplicates
    if (document.querySelector(`script[src="${environment.pagesenseUrl}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = environment.pagesenseUrl;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(`Failed to load PageSense script: ${environment.pagesenseUrl}`);

    document.head.appendChild(script);
  });
}

// Bootstrap app after PageSense (if enabled)
loadPageSense().finally(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});